module.exports = __webpack_public_path__ + "static/card11-64aace70c3bd3f30c33e24501a35bcbf.png";